var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRank1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2084 12.32H5.86328L6.5585 10.0605H9.51318L10.2084 12.32Z",
    fill: "url(#paint0_linear_6686_16420)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73428 12.3193H11.3389C11.7212 12.3193 12.0341 12.6322 12.0341 13.0146V14.2312H4.03906V13.0146C4.03906 12.6322 4.35191 12.3193 4.73428 12.3193Z",
    fill: "url(#paint1_linear_6686_16420)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60436 14.2314H12.4684C12.9968 14.2314 13.4243 14.659 13.4243 15.1874C13.4243 15.7157 12.9968 16.1433 12.4684 16.1433H3.60436C3.076 16.1433 2.64844 15.7157 2.64844 15.1874C2.64844 14.6625 3.076 14.2314 3.60436 14.2314Z",
    fill: "url(#paint2_linear_6686_16420)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8215 4.56713C13.9953 4.56713 14.044 4.61579 14.0753 4.64708C14.1135 4.68531 14.1309 4.7166 14.1413 4.76874C14.1552 4.83131 14.1691 4.96688 14.1135 5.19978C13.9849 5.75248 13.5747 6.40251 12.9907 6.98649C12.1321 7.84509 11.3292 8.15098 10.9051 8.15098C10.7313 8.15098 10.6826 8.10232 10.6513 8.07103C10.6131 8.0328 10.5957 8.00151 10.5853 7.94937C10.5714 7.8868 10.5575 7.75123 10.6131 7.51834C10.7417 6.96564 11.1519 6.3156 11.7359 5.73162C12.5945 4.87302 13.394 4.56713 13.8215 4.56713ZM13.8215 2.65527C12.7335 2.65527 11.4682 3.29488 10.3837 4.37942C8.69081 6.07228 8.08249 8.2066 9.29913 9.42324C9.73711 9.86122 10.2933 10.0628 10.9016 10.0628C11.9896 10.0628 13.2549 9.42324 14.3395 8.33869C16.0323 6.64583 16.6406 4.51151 15.424 3.29488C14.9895 2.85689 14.4333 2.65527 13.8215 2.65527Z",
    fill: "url(#paint3_linear_6686_16420)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24493 4.56713C2.67249 4.56713 3.47199 4.87302 4.33059 5.73162C4.91457 6.3156 5.32475 6.96911 5.45337 7.51834C5.50898 7.75123 5.49508 7.8868 5.48117 7.94937C5.47075 8.00151 5.45337 8.0328 5.41513 8.07103C5.38384 8.10232 5.33518 8.15098 5.16137 8.15098C4.73381 8.15098 3.93431 7.84509 3.07571 6.98649C2.49173 6.40251 2.08155 5.75248 1.95293 5.19978C1.89732 4.96688 1.91122 4.83131 1.92513 4.76874C1.93555 4.7166 1.95293 4.68531 1.99117 4.64708C2.02246 4.61579 2.07112 4.56713 2.24493 4.56713ZM2.24493 2.65527C1.63313 2.65527 1.07696 2.85689 0.638969 3.29488C-0.577665 4.51151 0.0306522 6.64583 1.72351 8.33869C2.80805 9.42324 4.07335 10.0628 5.16137 10.0628C5.77317 10.0628 6.32934 9.86122 6.76385 9.42324C7.98049 8.2066 7.37217 6.07228 5.67931 4.37942C4.59825 3.29488 3.33295 2.65527 2.24493 2.65527Z",
    fill: "url(#paint4_linear_6686_16420)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14053 7.13679V6.20867C4.14053 5.39874 4.00844 4.59229 3.72688 3.83102C3.54612 3.34089 3.44531 2.81252 3.44531 2.25635H12.6292C12.6292 2.80905 12.5284 3.34089 12.3476 3.83102C12.066 4.58881 11.9339 5.39874 11.9339 6.20867V7.13679C11.9339 9.28849 10.1889 11.0335 8.03724 11.0335C5.88553 11.0335 4.14053 9.28849 4.14053 7.13679Z",
    fill: "url(#paint5_linear_6686_16420)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43051 0H12.6422C13.2644 0 13.7719 0.50751 13.7719 1.12973C13.7719 1.75195 13.2644 2.25946 12.6422 2.25946H3.43051C2.80829 2.25946 2.30078 1.75195 2.30078 1.12626C2.30078 0.504034 2.80829 0 3.43051 0Z",
    fill: "url(#paint6_linear_6686_16420)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03093 8.3846C9.37478 8.3846 10.4642 7.29519 10.4642 5.95134C10.4642 4.60748 9.37478 3.51807 8.03093 3.51807C6.68707 3.51807 5.59766 4.60748 5.59766 5.95134C5.59766 7.29519 6.68707 8.3846 8.03093 8.3846Z",
    fill: "url(#paint7_linear_6686_16420)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07726 7.55713V7.10524L7.64734 7.03571V5.00567L7.07031 4.99872V4.57116L8.41904 4.34521V7.03571L8.98912 7.10524V7.55713H7.07726Z",
    fill: "url(#paint8_linear_6686_16420)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6686_16420",
    x1: 8.03602,
    y1: 10.0623,
    x2: 8.03602,
    y2: 12.3217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDAC33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6686_16420",
    x1: 8.03675,
    y1: 14.2329,
    x2: 8.03675,
    y2: 12.3211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D5969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6686_16420",
    x1: 8.03656,
    y1: 16.145,
    x2: 8.03656,
    y2: 14.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6686_16420",
    x1: 8.50463,
    y1: 6.89976,
    x2: 16.2192,
    y2: 5.81557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E46912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F69929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDAC33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6686_16420",
    x1: 7.56165,
    y1: 6.89976,
    x2: -0.15299,
    y2: 5.8156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E46912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F69929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDAC33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6686_16420",
    x1: 8.03724,
    y1: 2.25809,
    x2: 8.03724,
    y2: 11.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6686_16420",
    x1: 8.03652,
    y1: 2.25773,
    x2: 8.03652,
    y2: -0.00173811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6686_16420",
    x1: 8.0311,
    y1: 8.3846,
    x2: 8.0311,
    y2: 3.51807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6686_16420",
    x1: 8.03302,
    y1: 7.55782,
    x2: 8.03302,
    y2: 4.34521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD7600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FDBF30"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank1);
export default __webpack_public_path__ + "static/media/rank1.a0c482583a5f57b14107094f49cbdbad.svg";
export { ForwardRef as ReactComponent };